import request from '@/services/base/request';
import ServicesEnum from '@/services/_helpers/_types';
export default {
    getSpotExchangeInfo: (data) => request(ServicesEnum.binancePublic, '/api/v3/exchangeInfo', 'get', data),
    getMABinanceRate: (data) => request(ServicesEnum.binancePublicFutures, '/fapi/v1/assetIndex', 'get', null),
    getSymbolPrice: (data, symbol) => request(ServicesEnum.binancePublic, `/api/v3/ticker/price?symbol=${symbol}`, 'get', data),
    getSymbolsPrice: (data, symbols) => request(ServicesEnum.binancePublic, `/api/v3/ticker/price?symbols=${symbols}`, 'get', data),
    doPingToBinance: (data) => request(ServicesEnum.binancePublic, '/api/v3/ping', 'get', data)
};
